import styled from 'styled-components'

export const CreateCollaboWrapper = styled.form`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  margin-top: 23px;
  height: 85vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h4 {
    font-size: 16px;
    line-height: 4px;
    color: ${({ theme }) => theme.colors.NeutralBlack};
    opacity: 0.4;
  }
  .line-height {
    line-height: 24px;
  }
  .input {
    margin-top: 40px;
  }
  .input-two {
    margin-top: 5px;
  }
  .search-bar {
    display: flex;
    align-items: center;
    position: relative;
  }
  .added-user {
    display: flex;
    align-items: center;
  }
  .search {
    cursor: pointer;
    position: absolute;
    right: 12px;
    color: ${({ theme }) => theme.colors.primary};
  }
  .css-b62m3t-container {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #858c94;
    box-sizing: border-box;
    border-radius: 8px;
    height: 60px;
  }
  .css-1s2u09g-control {
    height: 60px;
  }
  .css-14dclt2-Input {
    font-size: 14px;
    line-height: 24px;
    color: #6e7191;
    opacity: 0.8;
    padding-left: 16px;
  }
  .css-1okebmr-indicatorSeparator {
    background-color: transparent;
  }
  .css-1hb7zxy-IndicatorsContainer {
    border-bottom: 1px solid #858c94;
  }
  .css-319lph-ValueContainer {
    height: 60px;
    border-bottom: 1px solid #858c94;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .target {
    width: 220px;
    background-color: ${({ theme }) => theme.colors.successGreen};
  }
  .targetTitle {
    color: ${({ theme }) => theme.colors.CollaboBlue};
  }
  .targets {
    width: 400px;
    background-color: ${({ theme }) => theme.colors.successGreen};
  }
  .top {
    text-align: center;
    margin-top: 50px;
  }
  .frequency {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .details-amount {
    margin-left: 35px;
  }
  .reverse {
    margin-top: -20px;
    color: ${({ theme }) => theme.colors.primary};
  }
  .blur {
    background-color: #6e7191;
    opacity: 1;
  }
  .container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 22px;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.NeutralBlack};
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border-radius: 50%;
  }

  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  .container input:checked ~ .checkmark {
    background-color: #2196f3;
  }

  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  .container input:checked ~ .checkmark:after {
    display: block;
  }

  .container .checkmark:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: white;
  }
`
export const FormContainer = styled.div`
  .form-group {
    position: relative;
    margin-bottom: 25px;

    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-right: 40px;
    }
  }
  .form-group.has-error input {
    border: 1px solid red;
  }
  .amount-pad {
    margin-top: -10px;
  }
  .form-group-select {
    margin-top: -15px;
  }
  .details-amount {
    margin-top: -5px;
  }
  .form-group.has-error .error-icon {
    display: block;
  }

  .error-icon {
    position: absolute;
    top: 12px;
    right: 0px;
    font-size: 24px;
    display: none;
    color: red;
  }

  .error-text {
    text-align: left;
    margin: 0 26px;
    padding-top: 4px;
    text-transform: capitalize;
    color: red;
    font-size: ${({ theme }) => theme.fontSize.s};
  }

  .form-group input:focus {
    border: 1px solid blue;
  }
`
